import { __mediamax_api_url_config__ } from '@/constants/appConfig'
import { shoppableGet } from '@/shared/shoppableApi'
import type { CampaignConfigResponse } from './types'

export const getCampaignConfigApi = (brandId: string) =>
  shoppableGet<CampaignConfigResponse>(
    __mediamax_api_url_config__.getCampaignConfig,
    brandId,
    'Failed to fetch campaign config',
    { skipForbiddenRedirect: true }
  )
